import FileRequest from './FileRequest';

export const FileRequestConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/file_request',
            component: FileRequest
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/fileRequest/FileRequestConfig.js